import React from "react";
import PropTypes from "prop-types";

import { Media } from "components/Media";

import css from "./MediaWrapper.module.scss";

import cn from 'classnames';

const MediaWrapper = ({ children, media, stickyDuration, theme, gradient, isLandingPage, hasGradient, className, bottomAligned }) => {
    const fixedStyle = stickyDuration
        ? { height: `${100 + stickyDuration}vh` }
        : {};
    return (
       
        <div className={cn(css.mediaWrapper, className, {
            [css.isLandingPage]: isLandingPage
        })}  
        style={fixedStyle}>
            <Media {...media} gradient={gradient} theme={theme} hasGradient={hasGradient}/>
            <div 
                className={cn(css.childWrapper, {
                    [css.bottomAligned]: bottomAligned
                })}
            >{children}</div>
        </div>
        
    );
};

MediaWrapper.themes = Media.themes;
MediaWrapper.gradients = Media.gradients;

MediaWrapper.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node)
    ]),
    theme: PropTypes.string,
    media: PropTypes.object,
    gradient: PropTypes.string,
    stickyDuration: PropTypes.number,
    isLandingPage: PropTypes.bool,
    hasGradient:PropTypes.bool,
    bottomAligned: PropTypes.bool,
    className: PropTypes.string
};

export default MediaWrapper;



// WEBPACK FOOTER //
// ./src/components/MediaWrapper/MediaWrapper.jsx